/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Tag_Create_SubmitInputs */



/**
* | output |
* | --- |
* | "Create tag" |
*
* @param {Project_Tag_Create_SubmitInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_tag_create_submit = /** @type {((inputs?: Project_Tag_Create_SubmitInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Tag_Create_SubmitInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Tag erstellen")
	return /** @type {LocalizedString} */ ("Create tag")
});